/**
 * Amortecimento exponencial, independente da taxa de quadros.
 *
 * Um valor que persegue o alvo por interpolação fixa por quadro anda mais
 * devagar a 30 fps que a 144 fps; aqui o passo depende do tempo decorrido, e o
 * movimento sai igual em qualquer máquina. O amortecimento chega perto do alvo
 * sem ultrapassá-lo, sem tranco no início e sem corte no fim.
 */

/** Fração do caminho percorrida no tempo de assentamento (99%). */
const FRACAO_NO_ASSENTAMENTO = 0.99

/**
 * Fração do caminho até o alvo que se percorre em `delta` segundos, para um
 * movimento que assenta (chega a 99%) em `tempoDeAssentamento` segundos.
 */
export function fracaoDoPasso(tempoDeAssentamento: number, delta: number): number {
  if (tempoDeAssentamento <= 0) return 1
  if (delta <= 0) return 0
  const taxa = -Math.log(1 - FRACAO_NO_ASSENTAMENTO) / tempoDeAssentamento
  return 1 - Math.exp(-taxa * delta)
}

/** Passo de `atual` rumo a `alvo`; com `instantaneo` (movimento reduzido) já chega. */
export function amortecer(
  atual: number,
  alvo: number,
  tempoDeAssentamento: number,
  delta: number,
  instantaneo = false,
): number {
  if (instantaneo) return alvo
  const proximo = atual + (alvo - atual) * fracaoDoPasso(tempoDeAssentamento, delta)
  // abaixo de um milésimo o resto é imperceptível: chega de vez em vez de rastejar
  return Math.abs(alvo - proximo) < 1e-3 ? alvo : proximo
}

/** Cor RGB (0 a 1) em direção a outra, no mesmo ritmo de `amortecer`. */
export function amortecerCor(
  atual: readonly [number, number, number],
  alvo: readonly [number, number, number],
  tempoDeAssentamento: number,
  delta: number,
  instantaneo = false,
): [number, number, number] {
  return [
    amortecer(atual[0], alvo[0], tempoDeAssentamento, delta, instantaneo),
    amortecer(atual[1], alvo[1], tempoDeAssentamento, delta, instantaneo),
    amortecer(atual[2], alvo[2], tempoDeAssentamento, delta, instantaneo),
  ]
}

export function prefereMovimentoReduzido(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  )
}
